import * as React from 'react';
import { SystemIconType } from '../types';
/**
 * @deprecated Please use @fiverr-private/visuals package.
 */
const AttachmentIcon = ({
    size = 16,
    color = 'currentFill'
}: SystemIconType) => (
    <svg xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 10 16"
        fill={color}>
        <path fillRule="evenodd"
            clipRule="evenodd"
            d="M3.689 1.485A2.208 2.208 0 0 0 1.475 3.71v7.258A3.527 3.527 0 0 0 5 14.515a3.527 3.527 0 0 0 3.525-3.546V2.722c0-.41.33-.743.737-.743a.74.74 0 0 1 .738.743v8.247C10 13.754 7.768 16 5 16s-5-2.246-5-5.03V3.71A3.688 3.688 0 0 1 3.689 0a3.688 3.688 0 0 1 3.688 3.711v6.598A2.368 2.368 0 0 1 5 12.701a2.368 2.368 0 0 1-2.377-2.392V4.701c0-.41.33-.742.738-.742a.74.74 0 0 1 .737.742v5.608c0 .514.391.908.902.908.51 0 .902-.394.902-.908V3.711c0-1.24-.982-2.226-2.213-2.226Z"/>
    </svg>
);
AttachmentIcon.displayName = 'AttachmentIcon';
export default AttachmentIcon;
